import { cn } from "@/lib/utils";

export interface TabItem {
  key: string;
  label: string;
}

interface TabBarProps {
  tabs: TabItem[];
  value: string;
  onChange: (key: string) => void;
  className?: string;
}

/**
 * Underline tab strip used on entity detail pages (Overview / … / Change
 * history). Active tab gets a navy underline; the rest are muted.
 */
export function TabBar({ tabs, value, onChange, className }: TabBarProps) {
  return (
    <div className={cn("flex gap-0.5 border-b", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={cn(
            "-mb-px border-b-2 px-3.5 py-2.5 text-sm font-semibold transition-colors",
            value === tab.key
              ? "border-primary text-foreground"
              : "border-transparent text-muted-foreground hover:text-foreground",
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
